import { ProviderAuthenticationCommon } from '~/plugins/data-connector/authentication/common'

export const ProviderDiscordCommon = {
  key: 'discord',
  authentication: ProviderAuthenticationCommon.Form(),
}

export type ProviderDiscordAccountType = {
  input: {
    serverId: string
  }
}
